import React from "react";

const InstagramIcon = () => (
  <svg fillRule="nonzero" height="34px" width="34px" viewBox="0,0,256,256" xmlns="http://www.w3.org/2000/svg" className="instagram">
    <g style={{ mixBlendMode: 'normal' }} strokeDashoffset={0} strokeMiterlimit={10} strokeLinejoin="miter" strokeLinecap="butt" strokeWidth={1} stroke="none" fillRule="nonzero">
      <g transform="scale(8,8)">
        <path d="M11.46875,5c-3.55078,0 -6.46875,2.91406 -6.46875,6.46875v9.0625c0,3.55078 2.91406,6.46875 6.46875,6.46875h9.0625c3.55078,0 6.46875,-2.91406 6.46875,-6.46875v-9.0625c0,-3.55078 -2.91406,-6.46875 -6.46875,-6.46875zM11.46875,7h9.0625c2.47266,0 4.46875,1.99609 4.46875,4.46875v9.0625c0,2.47266 -1.99609,4.46875 -4.46875,4.46875h-9.0625c-2.47266,0 -4.46875,-1.99609 -4.46875,-4.46875v-9.0625c0,-3.55078 1.99609,-4.46875 4.46875,-4.46875zM21.90625,9.1875c-0.50391,0 -0.90625,0.40234 -0.90625,0.90625c0,0.50391 0.40234,0.90625 0.90625,0.90625c0.50391,0 0.90625,-0.40234 0.90625,-0.90625c0,-0.50391 -0.40234,-0.90625 -0.90625,-0.90625zM16,10c-3.30078,0 -6,2.69922 -6,6c0,3.30078 2.69922,6 6,6c3.30078,0 6,-2.69922 6,-6c0,-3.30078 -2.69922,-6 -6,-6zM16,12c2.22266,0 4,1.77734 4,4c0,2.22266 -1.77734,4 -4,4c-2.22266,0 -4,-1.77734 -4,-4c0,-2.22266 1.77734,-4 4,-4z" />
      </g>
    </g>
  </svg>
);

const GithubIcon = () => (
  <svg height="34px" width="34px" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" className="github">
    <path d="M15,3C8.373,3,3,8.373,3,15c0,5.623,3.872,10.328,9.092,11.63C12.036,26.468,12,26.28,12,26.047v-2.051 c-0.487,0-1.303,0-1.508,0c-0.821,0-1.551-0.353-1.905-1.009c-0.393-0.729-0.461-1.844-1.435-2.526 c-0.289-0.227-0.069-0.486,0.264-0.451c0.615,0.174,1.125,0.596,1.605,1.222c0.478,0.627,0.703,0.769,1.596,0.769 c0.433,0,1.081-0.025,1.691-0.121c0.328-0.833,0.895-1.6,1.588-1.962c-3.996-0.411-5.903-2.399-5.903-5.098 c0-1.162,0.495-2.286,1.336-3.233C9.053,10.647,8.706,8.73,9.435,8c1.798,0,2.885,1.166,3.146,1.481C13.477,9.174,14.461,9,15.495,9 c1.036,0,2.024,0.174,2.922,0.483C18.675,9.17,19.763,8,21.565,8c0.732,0.731,0.381,2.656,0.102,3.594 c0.836,0.945,1.328,2.066,1.328,3.226c0,2.697-1.904,4.684-5.894,5.097C18.199,20.49,19,22.1,19,23.313v2.734 c0,0.104-0.023,0.179-0.035,0.268C23.641,24.676,27,20.236,27,15C27,8.373,21.627,3,15,3z" />
  </svg>
);

const LinkedinIcon = () => (
  <svg height="34px" width="34px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="linkedin" fill="currentColor">
    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 .784.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
  </svg>
);

const YoutubeIcon = () => (
  <svg height="34px" width="34px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="youtube" fill="currentColor">
    <path d="M23.498 6.163c-.272-1.022-1.074-1.824-2.096-2.097C19.558 3.5 12 3.5 12 3.5s-7.558 0-9.402.566c-1.022.273-1.824 1.075-2.097 2.097C0 8.007 0 12 0 12s0 3.993.502 5.837c.273 1.022 1.075 1.824 2.097 2.097 1.844.566 9.402.566 9.402.566s7.558 0 9.402-.566c1.022-.273 1.824-1.075 2.096-2.097C24 15.993 24 12 24 12s0-3.993-.502-5.837zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

const XIcon = () => (
  <svg viewBox="0 0 24 24" height="34px" width="34px" xmlns="http://www.w3.org/2000/svg" className="x-logo" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const MediumIcon = () => (
  <svg viewBox="0 0 24 24" height="34px" width="34px" xmlns="http://www.w3.org/2000/svg" className="medium" fill="currentColor">
    <path d="M13.54 12a6.8 6.8 0 0 1-6.77 6.82A6.8 6.8 0 0 1 0 12a6.8 6.8 0 0 1 6.77-6.82A6.8 6.8 0 0 1 13.54 12zm7.42 0c0 3.54-1.51 6.42-3.38 6.42s-3.38-2.88-3.38-6.42 1.51-6.42 3.38-6.42 3.38 2.88 3.38 6.42zm3.04 0c0 3.24-.38 5.87-.85 5.87s-.85-2.63-.85-5.87.38-5.87.85-5.87.85 2.63.85 5.87z" />
  </svg>
);

const SubstackIcon = () => (
  <svg viewBox="0 0 24 24" height="34px" width="34px" xmlns="http://www.w3.org/2000/svg" className="substack" fill="currentColor">
    <path d="M22.539 8.242H1.46V5.406h21.08v2.836zm0 5.482H1.46v-2.837h21.08v2.837zm0 7.602L12 15.371l-10.54 5.955V11.23h21.08v10.094z" />
  </svg>
);

const TiktokIcon = () => (
  <svg viewBox="0 0 16 16" height="34px" width="34px" xmlns="http://www.w3.org/2000/svg" className="tiktok" fill="currentColor">
    <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z" />
  </svg>
);

interface SocialHoverGridProps {
  getSocialUrl: (platformName: string, fallbackUrl: string) => string;
}

interface SocialStaticItem {
  title: string;
  urlKey: string;
  fallbackUrl: string;
  icon: React.ReactNode;
}

const socialItems: SocialStaticItem[] = [
  {
    title: "Instagram (TR)",
    urlKey: "Instagram (TR)",
    fallbackUrl: "https://www.instagram.com/benugurcanuzunkaya/",
    icon: <InstagramIcon />
  },
  {
    title: "Instagram (EN)",
    urlKey: "Instagram (EN)",
    fallbackUrl: "https://www.instagram.com/iamugurcanuzunkaya/",
    icon: <InstagramIcon />
  },
  {
    title: "X / Twitter",
    urlKey: "X",
    fallbackUrl: "https://x.com/ugurcanuznkaya",
    icon: <XIcon />
  },
  {
    title: "Github",
    urlKey: "Github",
    fallbackUrl: "https://github.com/ugurcanuzunkaya",
    icon: <GithubIcon />
  },
  {
    title: "LinkedIn",
    urlKey: "Linkedin",
    fallbackUrl: "https://linkedin.com/in/ugurcanuzunkaya",
    icon: <LinkedinIcon />
  },
  {
    title: "YouTube",
    urlKey: "Youtube",
    fallbackUrl: "https://www.youtube.com/@benugurcanuzunkaya",
    icon: <YoutubeIcon />
  },
  {
    title: "Medium",
    urlKey: "Medium",
    fallbackUrl: "https://medium.com/@ugurcanuzunkaya1",
    icon: <MediumIcon />
  },
  {
    title: "Substack",
    urlKey: "Substack",
    fallbackUrl: "https://ugurcanuzunkaya.substack.com/",
    icon: <SubstackIcon />
  },
  {
    title: "Linktree",
    urlKey: "Linktree",
    fallbackUrl: "https://linktr.ee/ugurcanuzunkaya",
    icon: (
      <img
        src="https://static.vecteezy.com/system/resources/previews/068/764/227/non_2x/linktree-logo-icon-linktree-app-transparent-background-free-png.png"
        alt="Linktree"
        className="w-[34px] h-[34px] object-contain"
      />
    )
  },
  {
    title: "Kick",
    urlKey: "Kick",
    fallbackUrl: "https://kick.com/ugurcanuzunkaya",
    icon: (
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Kick.com_icon_logo.svg/3840px-Kick.com_icon_logo.svg.png"
        alt="Kick"
        className="w-[34px] h-[34px] object-contain"
      />
    )
  },
  {
    title: "Club.com",
    urlKey: "Club.com",
    fallbackUrl: "https://club.com/ugurcanuzunkaya",
    icon: (
      <img
        src="https://club.com/images/favicons/club-favicon-512x512.png"
        alt="Club.com"
        className="w-[34px] h-[34px] object-contain rounded-full"
      />
    )
  },
  {
    title: "TikTok",
    urlKey: "Tiktok",
    fallbackUrl: "https://tiktok.com/@ugurcanuzunkaya",
    icon: <TiktokIcon />
  }
];

export function SocialHoverGrid({ getSocialUrl }: SocialHoverGridProps) {
  return (
    <div className="social-hover-container">
      <div className="social-hover-main">
        {socialItems.map((item) => (
          <a
            key={item.title}
            href={getSocialUrl(item.urlKey, item.fallbackUrl)}
            target="_blank"
            rel="noopener noreferrer"
            className="social-hover-card"
            title={item.title}
          >
            {item.icon}
          </a>
        ))}
        <p className="social-hover-text">HOVER<br /><br />FOR<br /><br />SOCIAL</p>
        <div className="social-hover-main-back" />
      </div>
    </div>
  );
}
